import { filter, filterBy, union } from '@ember/object/computed';
import Em from 'ember';
export default Em.Mixin.create({
  appAttributes: Em.computed(function () {
    return Em.A([Em.Object.create({
      name: 'Author name',
      identifier: 'message.author.first_name',
      templatable_identifier: 'message.author.first_name',
      noFallback: true,
      isApp: true //TODO: GJ: do we need isApp?
    }), Em.Object.create({
      name: 'Author full name',
      identifier: 'message.author.name',
      templatable_identifier: 'message.author.name',
      noFallback: true,
      isApp: true
    }), Em.Object.create({
      name: 'App name',
      identifier: 'app.name',
      templatable_identifier: 'app.name',
      noFallback: true,
      isApp: true
    })]);
  }),
  templatableAttributes: filter('attributes', function (attribute) {
    return !!attribute.get('templatable_identifier');
  }),
  eventAttributes: Em.computed('templatableAttributes', function () {
    let eventAttributes = [];
    this.get('templatableAttributes').forEach(function (item) {
      let itemData;
      if (item.get('isUserEvent')) {
        if (item.get('isTransformedUserEvent')) {
          eventAttributes.pushObject(item);
        } else {
          itemData = item.toJSON();
          eventAttributes.pushObject(this.duplicateEventAttribute(itemData, 'count'));
          eventAttributes.pushObject(this.duplicateEventAttribute(itemData, 'first'));
          eventAttributes.pushObject(this.duplicateEventAttribute(itemData, 'last'));
        }
      }
    }, this);
    return eventAttributes;
  }),
  selectedEventMetadataIdentifiers: Em.computed('selectedEvents', function () {
    if (!this.get('selectedEvents')) {
      return [];
    }
    return this.get('selectedEvents').reduce((eventIdentifiers, selectedEvent) => {
      let selectedEventMetadata = selectedEvent.get('metadata') || [];
      return eventIdentifiers.concat(selectedEventMetadata.map(metadata => metadata.identifier));
    }, []);
  }),
  eventMetadataAttributes: Em.computed('templatableAttributes', 'selectedEventMetadataIdentifiers', function () {
    let selectedEventMetadataIdentifiers = this.get('selectedEventMetadataIdentifiers');
    let eventMetadataAttributes = [];
    this.get('templatableAttributes').forEach(attribute => {
      if (attribute.get('isUserEventMetadata')) {
        let isSelectedEventMetadata = selectedEventMetadataIdentifiers.includes(attribute.get('identifier'));
        attribute.set('isSelectedEventMetadata', isSelectedEventMetadata);
        eventMetadataAttributes.push(attribute);
      }
    });
    return eventMetadataAttributes;
  }),
  duplicateEventAttribute(itemData, type) {
    let itemToDuplicate = Em.Object.create(itemData);
    itemToDuplicate.set('templatable_identifier', `${itemToDuplicate.get('templatable_identifier')}.${type}`);
    itemToDuplicate.set('name', `${itemToDuplicate.get('name').replace(/_|\-/g, ' ')} ${type}`);
    itemToDuplicate.set('isUser', true);
    itemToDuplicate.set('isUserEvent', true);
    itemToDuplicate.set('isTransformedUserEvent', true);
    return itemToDuplicate;
  },
  companyAttributes: filterBy('templatableAttributes', 'isCompany'),
  userAttributes: filter('templatableAttributes', function (item) {
    return item.get('isUser') && !item.get('isUserEvent');
  }),
  conversationAttributes: filterBy('templatableAttributes', 'isConversation'),
  customObjectAttributes: Em.computed('customObjectAttributeGroups', function () {
    let customObjectAttributes = [];
    if (!this.get('customObjectAttributeGroups')) {
      return customObjectAttributes;
    }
    this.get('customObjectAttributeGroups').forEach(customObjectAttributeGroup => customObjectAttributes.pushObjects(customObjectAttributeGroup.attributes));
    return customObjectAttributes;
  }),
  combinedAttributes: union('userAttributes', 'companyAttributes', 'appAttributes', 'eventAttributes', 'eventMetadataAttributes', 'conversationAttributes', 'customObjectAttributes')
});